import { connect } from 'react-redux'
import View from './Modal'

const mapStateToProps = state => ({
  locale: state.router.locale,
})

const Modal = connect(mapStateToProps)(View)

export default Modal
